import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, logout} from "../../../features/user";
//import { setLoading} from "../../features/common";
import { useTranslation } from 'react-i18next';
import {checkValidToken,userLoggedIn} from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import ListCard from '../../widgets/ListCard';

export function GraphicList() {
    const [state, setState] = useState({ search: "" });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        checkValidToken(navigate, dispatch, false, true, "/start");
        userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch);
       // eslint-disable-next-line
    },[]);


    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value,
        });
    };

    return (
        <Frame headerWhite={true} showMenu={true} showNav={true}>
            <div className='main graphic-list'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                    <Background >
                        <div className='right-main-inner'>
                            <ListCard title={"logo_and_branding"} items={[{name:"logo_design_for_the_writer"}, {name:"website_design_for_the_writer"}, {name:"book_branding"}]}></ListCard>
                            <div className='mb40'></div>
                            <ListCard title={"packaging_and_covers"} items={[{name:"cover_design"}, {name:"typesetting"}, {name:"packages_and_labels_design"}]}></ListCard>
                            <div className='mb40'></div>
                            <ListCard title={"illustration_and_art"} items={[{name:"books_illustration"}, {name:"comics_and_children_illustration"}, {name:"ai_art"}]}></ListCard>
                            <div className='mb40'></div>
                            <ListCard title={"design_and_printing"} items={[{name:"bookmark_design"}, {name:"postcard_design"}, {name:"ai_art", subcategory:"ai_art_dp"}]}></ListCard>
                            <div className='mb40'></div>
                        </div>
                    </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}